import React from 'react'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate } from 'react-router-dom';
import { IMG_BASE_URL } from '../../../config/Config';
const Similar_Product = (props) => {
    const { data } = props
    const navigate = useNavigate()
    const get_product_details_list = data;

    const settings = {
        infinite: get_product_details_list?.length > 4,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    infinite: get_product_details_list?.length > 4,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    infinite: get_product_details_list?.length > 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    infinite: get_product_details_list?.length > 1,
                },
            },
        ],
    };

    return (
        <div>
            {
                get_product_details_list?.length > 0 && (
                    <section className="gi-deal-section py-[40px] max-[767px]:py-[30px] bg-gray-100">
                        <div className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                            <div className="w-full flex flex-wrap px-[12px] overflow-hidden">
                                <div className="gi-deal-section w-full">
                                    <div className="gi-products text-center">
                                        <div className="section-title relative text-center md:pb-[20px] z-[0]" data-aos="fade-up"
                                            data-aos-duration="2000" data-aos-delay="200">
                                            <div className="section-detail">
                                                <h2 className="text-3xl bodonibook_font text-gray-900">
                                                    Similar Products</h2>
                                                {/* <p className="mt-[10px] text-[14px] text-[#777] leading-[18px]">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p> */}
                                            </div>

                                        </div>

                                        <div className="gi-deal-block relative z-0">
                                            {/* Slick Slider */}
                                            <Slider {...settings}>
                                                {/* Product Card 1 */}
                                                {
                                                    get_product_details_list?.map((product_list_result) => (
                                                       
                                                                <div key={product_list_result.id} className="gi-product-content h-full px-2">
                                                                    <div className="gi-product-inner transition-all duration-[0.3s] ease-in-out cursor-pointer bg-white hover:border hover:border-gray-300 shadow-xl rounded-lg overflow-hidden">
                                                                        <div className="gi-pro-image-outer transition-all duration-[0.3s] delay-[0s] ease z-[0] relative">
                                                                            <div className="gi-pro-image overflow-hidden">
                                                                                <div onClick={() =>
                                                                                    navigate(`/product/${product_list_result?.slug}`)
                                                                                } className="image productimg7 relative block overflow-hidden">
                                                                                    {
                                                                                        product_list_result?.product_images[0]?.file_type == "image" ? (
                                                                                            <img className="main-image !w-full h-[250px] object-cover object-center transition-all duration-[0.3s] ease delay-[0s]"
                                                                                                src={`${IMG_BASE_URL}${product_list_result?.product_images[0]?.image_url}`} alt={product_list_result?.alt_image_title} />
                                                                                        ) : (
                                                                                            <video
                                                                                                controls
                                                                                                poster={`${IMG_BASE_URL}${product_list_result?.product_images[0]?.thumbnail_url}`}
                                                                                                className="w-full h-[250px] object-cover object-center"
                                                                                            >
                                                                                                <source src={`${IMG_BASE_URL}${product_list_result?.product_images[0]?.thumbnail_url.video_url}`} type="video/mp4" />
                                                                                            </video>
                                                                                        )
                                                                                    }

                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="w-full h-1 bg-gray-100 rounded-[100%]"></div>

                                                                        <div className="gi-pro-content h-full p-[20px] pt-[0] relative z-[10] flex flex-col text-center">
                                                                            <h5 className="gi-pro-stitle mt-3 text-gray-900 text-[14px] font-semibold leading-[1.2] capitalize overflow-hidden whitespace-nowrap text-ellipsis">
                                                                                {product_list_result?.name}
                                                                            </h5>
                                                                            <div className="text-[12px] text-gray-900 font-medium py-2">Origin: {product_list_result?.origin?.name}</div>
                                                                            <div className="flex justify-between gap-3 items-center mt-2">
                                                                                <div className="gi-pro-rat-price mt-[5px] mb-[0] flex flex-col">
                                                                                    <span className="gi-price">
                                                                                        <span className="new-price text-gray-900 font-bold text-[14px]">Rs.{product_list_result?.purchase_price}</span>
                                                                                    </span>
                                                                                </div>
                                                                                <button type='button' onClick={() =>
                                                                                    navigate(`/product/${product_list_result?.slug}`)
                                                                                } className="text-[12px] uppercase bg-gray-100 text-gray-900 font-medium px-3 py-2 hover:bg-gray-400">
                                                                                    View More
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                        
                                                    ))
                                                }

                                                {/* Add more products as needed */}
                                            </Slider>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                )
            }
        </div>
    )
}

export default Similar_Product